// What the Agents place's Sections share (BL-189): how a part says it's loading or failed (as
// ListPage's regions say it: skeleton rows, then the red sentence and Try again), the Every agent
// choice, and a chip's tone as RowList's word.

import type { ReactNode } from 'react';
import { Link, Skeleton, SkeletonGroup, type RowTone } from '@flowology/ui-web/fl';

/** A chip's tone (model.ts' MODE_CHIP, runs-model.ts' RUN_STATUS) as RowList's word: ok is ink. */
export const toneOf = (chip: string): RowTone =>
  chip === 'warn' ? 'wait' : chip === 'bad' ? 'bad' : chip === 'muted' || chip === '' ? 'muted' : 'ink';

/** Every agent, then each by name (Activity today's and Recent runs' choice). */
export const agentOptions = (names: Map<string, string>) => [
  { value: '', label: 'Every agent' },
  ...[...names].map(([value, label]) => ({ value, label })),
];

/** A part's rows once they're in; skeleton rows while they load; the red sentence and Try again. */
export function PartSays({
  status,
  what,
  failedText,
  onRetry,
  children,
}: {
  status: 'ready' | 'loading' | 'failed';
  /** What it lists ("today’s activity"). */
  what: string;
  failedText?: string | undefined;
  onRetry: () => void;
  children: ReactNode;
}) {
  if (status === 'loading')
    return (
      <SkeletonGroup label={`Loading ${what}`}>
        {[0, 1, 2].map((i) => (
          <Skeleton key={i} shape="row" width="full" />
        ))}
      </SkeletonGroup>
    );
  if (status === 'failed')
    return (
      <p className="agents-failed" role="alert">
        <span>{failedText ?? `Couldn’t load ${what}.`}</span> <Link onPress={onRetry}>Try again</Link>
      </p>
    );
  return <>{children}</>;
}
